import axios from 'axios';
import { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const InactivityHandler = ({ children, timeout = 1200000 }) => {
  const navigate = useNavigate();
  const logoutTimer = useRef(null);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const email = sessionStorage.getItem('email');

  const resetTimer = useCallback(async() => {
    if (logoutTimer.current) {
      clearTimeout(logoutTimer.current);
    }
    logoutTimer.current = setTimeout(async() => {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('merchantId');
      sessionStorage.removeItem('roles');
      await axios.get(`${baseUrl}/account/logout/${email}`)
      navigate('/login');
    }, timeout);
  }, [timeout, navigate, baseUrl, email]);

  const handleActivity = useCallback(() => {
    resetTimer();
  }, [resetTimer]);

  useEffect(() => {
    document.addEventListener('mousemove', handleActivity);
    document.addEventListener('keydown', handleActivity);
    document.addEventListener('mousedown', handleActivity);
    document.addEventListener('touchstart', handleActivity);

    resetTimer();

    return () => {
      clearTimeout(logoutTimer.current);
      document.removeEventListener('mousemove', handleActivity);
      document.removeEventListener('keydown', handleActivity);
      document.removeEventListener('mousedown', handleActivity);
      document.removeEventListener('touchstart', handleActivity);
    };
  }, [handleActivity, resetTimer]);

  return children;
};

export default InactivityHandler;
